import { ThemeModule } from '../../front/lib/ThemeModule';
import { addLayoutResizeListener } from '../../front/lib/utils';
const pointRadius = 32;
export class ImageHotspot extends ThemeModule {
    init() {
        let firstEntryObserver = new IntersectionObserver(entries => entries.forEach(entry => {
            if (entry.isIntersecting) {
                points[0].showDetails();
            }
            else {
                points[0].hideDetails();
            }
        }), {
            threshold: 1,
            rootMargin: `-20% 0%`,
        });
        const unobserveFirstEntry = () => {
            if (firstEntryObserver) {
                firstEntryObserver.disconnect();
                firstEntryObserver = null;
            }
        };
        const points = this.querySelectorAll('.imageHotspotMod-point').map(el => {
            const tpl = el.querySelector('template');
            const isShown = () => el.classList.contains('is--open');
            let contentEl = null;
            return {
                root: el,
                get contentEl() { return contentEl; },
                isShown,
                showDetails: () => {
                    var _a;
                    if (isShown() || !tpl) {
                        return;
                    }
                    el.classList.add('is--open');
                    if (!contentEl) {
                        contentEl = tpl.content.cloneNode(true).querySelector('.imageHotspotMod-popup');
                        contentEl.classList.add('is--hidden');
                    }
                    if (!contentEl.parentElement) {
                        document.body.appendChild(contentEl);
                    }
                    const screenPadding = {
                        top: 16 + (((_a = document.querySelector('#SiteHeader:not(.is--hidden)')) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0),
                        right: 16,
                        bottom: 16,
                        left: 16,
                    };
                    const bbox = el.getBoundingClientRect();
                    const ppos = {
                        top: window.scrollY + bbox.top,
                        left: window.scrollX + bbox.left,
                    };
                    const targetPos = {
                        top: ppos.top - contentEl.offsetHeight * 0.34,
                        left: ppos.left + pointRadius,
                    };
                    if (targetPos.top < window.scrollY + screenPadding.top) {
                        targetPos.top = window.scrollY + screenPadding.top;
                    }
                    const rightOverreach = (targetPos.left + contentEl.offsetWidth + screenPadding.right) - window.innerWidth;
                    if (rightOverreach > 0) {
                        // targetPos.left -= rightOverreach; // <- This simply moves the popup to compensate for the overreach
                        targetPos.left = ppos.left - pointRadius - contentEl.offsetWidth; // <- This moves the popup to the left of the point
                    }
                    const bottomOverreach = (targetPos.top + contentEl.offsetHeight + screenPadding.bottom) - (window.scrollY + window.innerHeight);
                    if (bottomOverreach > 0) {
                        targetPos.top -= bottomOverreach;
                    }
                    contentEl.style.top = `${targetPos.top}px`;
                    contentEl.style.left = `${targetPos.left}px`;
                    setTimeout(() => contentEl.classList.remove('is--hidden'), 10);
                },
                hideDetails: () => {
                    if (!isShown() || !contentEl) {
                        return;
                    }
                    el.classList.remove('is--open');
                    contentEl.classList.add('is--hidden');
                },
            };
        });
        points.forEach(point => {
            point.root.addEventListener('click', e => {
                e.stopPropagation();
                unobserveFirstEntry();
                points.forEach(p => p !== point && p.hideDetails());
                point.isShown() ? point.hideDetails() : point.showDetails();
                const closeListener = (e2) => {
                    var _a;
                    const target = e2.target;
                    if (!((_a = point.contentEl) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                        point.hideDetails();
                        document.removeEventListener('click', closeListener);
                    }
                };
                document.addEventListener('click', closeListener);
            });
        });
        if (points.length) {
            firstEntryObserver.observe(points[0].root);
        }
        addLayoutResizeListener(() => points.forEach(p => p.hideDetails()));
    }
}
